import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const handlePendingViabilities = () => {
    window.location = '/pending-viabilities';
}

const handleCommerceCreation = () => {
    window.location = '/create-commerce';
}

const handleLoadedDocuments = () => {
    window.location = '/credits-to-review';
}

const handleDataAnalytics = () => {
    window.location = '/statistics';
}

const handleCobranza = () => {
    window.location = '/homeAdmin/cobranza';
}

const handleModifyParameters = () => {
    window.location = '/modify-parameters';
}
const handleFailedDeleteQuota = () => {
    window.location = '/homeAdmin/novedades-siigo';
}
export default function GeneralAdmin() {

    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }

    });

    return (
        <React.Fragment>
            <Header />
            <Container maxWidth="md">
                <br />
                <br />
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={7}>
                            <Stack spacing={8}>
                                <ButtonPrincipal variant="contained" onClick={handlePendingViabilities}>Viabilidades Pendientes</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleLoadedDocuments}>Revisión documentos cargados</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleCommerceCreation}>Creación Comercios</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleModifyParameters}>Modificar Parametros</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleDataAnalytics}>Indicadores y Análisis</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleCobranza}>Cobranza</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleFailedDeleteQuota}>Novedades en siigo</ButtonPrincipal>
                            </Stack>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}